export const SET_DOCUMENT_NATURE = (state, value) => {
  state.selectedDocument.documentNature = value
}

export const SET_REPRESENTATION_TYPE = (state, value) => {
  state.selectedDocument.representationType = value
}

export const SET_DOCUMENT_TYPE = (state, value) => {
  state.selectedDocument.documentType = value
}

export const SET_REPOSITORY_NAME = (state, value) => {
  state.selectedDocument.repositoryName = value
}

export const SET_URL = (state, value) => {
  state.selectedDocument.url = value
}

export const SET_REFERENCE = (state, value) => {
  state.selectedDocument.reference = value
}

export const SET_LIST = (state, value) => {
  state.list = value
}

export const SET_SELECTED_KEY = (state, value) => {
  state.selectedKey = value
}

export const setSelectedTransferDocument = (state, key) => {
  let selectedDocument = {..._getDocumentByKey(key, state)}
  state.selectedDocument = selectedDocument
  state.selectedKey = key
}

const _getDocumentByKey = (key, state) => {
  return state.list.find(document => document.key === key)
}

export const deleteDocument = (state, value) => {
  state.list = state.list.filter(document => document.key !== value.key)
}

export const ADD = (state, value) => {
  state.list.push(value)
}
